import ZeissButton from '@components/button';
import ZeissModal from '@components/zeiss-modal';
import { TARGET_STUFF } from '@views/pages/AnnouncementList/announcement';
import { Col, Form, Row, Space } from 'antd';
import {
  RenderFormDomInterface,
  rendercomponents
} from '../../../../utils/formRender';
import { initialSubjectMatterItemValues } from './CreateAnnouncement';
import { useEffect } from 'react';
import './CreateAnnouncement.scss';
interface Props {
  open: boolean;
  dicList: any;
  systemCity: any;
  setOpen: (val: boolean) => void;
  handleOk: (data: any) => void;
}
export const AddSubjectMatter = (props: Props) => {
  const { open, setOpen, dicList, systemCity, handleOk } = props;
  const [form] = Form.useForm();

  const addSubjectMatterClick = async () => {
    try {
      const values = await form.validateFields();
      // const { successfulPrice, successfulPriceRemark } = values;
      // if (!successfulPrice && !successfulPriceRemark) {
      //   message.error(subjectMatterErrorText);
      //   return;
      // }
      setOpen(false);
      handleOk(values);
    } catch (error) {
      console.log('error', error);
    }
  };

  const renderSelectOptions = (data: any) => {
    const { optionsListKey } = data;
    return dicList[optionsListKey] ?? [];
  };

  const obj: RenderFormDomInterface = {
    optionCallback: renderSelectOptions,
    systemCity
  };

  const subjectMatterNumberFromForm: string = Form.useWatch(
    'subjectMatterNumber',
    form
  );
  const totalAmountFromForm: string = Form.useWatch('totalAmount', form);
  const totalAmountCurrencyFromForm: string = Form.useWatch(
    'totalAmountCurrency',
    form
  );
  useEffect(() => {
    if (
      totalAmountFromForm &&
      subjectMatterNumberFromForm &&
      Number(totalAmountFromForm)
    ) {
      form.setFieldValue(
        'subjectMatterPrice',
        (
          Number(totalAmountFromForm) / Number(subjectMatterNumberFromForm)
        ).toFixed(2)
      );
    } else {
      form.setFieldValue('subjectMatterPrice', null);
    }
  }, [subjectMatterNumberFromForm, totalAmountFromForm]);
  useEffect(() => {
    if (totalAmountCurrencyFromForm) {
      form.setFieldValue(
        'subjectMatterCurrency',
        `${form.getFieldValue('totalAmountCurrency')}`
      );
    }
  }, [totalAmountCurrencyFromForm]);
  return (
    <ZeissModal
      open={open}
      width={740}
      centered
      footer={null}
      onCancel={() => setOpen(false)}
    >
      <div className="pc-createAnnouncementLayout">
        <div className="pc-createAnnouncement-title">添加标的物</div>
        <Form
          form={form}
          layout="vertical"
          initialValues={initialSubjectMatterItemValues}
        >
          <Row gutter={[24, 0]} justify={'space-between'}>
            {TARGET_STUFF.map((x, index) => (
              <Col span={11} key={index}>
                <Form.Item
                  label={x.label}
                  name={x.name}
                  rules={[{ required: x.required }]}
                >
                  {rendercomponents({
                    ...obj,
                    data: x,
                    dicList
                  })}
                </Form.Item>
              </Col>
            ))}
          </Row>
        </Form>
        <Space className="pc-createAnn-footer" size="middle">
          <ZeissButton
            className="pc-createAnn-cancel"
            onClick={() => setOpen(false)}
          >
            取消
          </ZeissButton>
          <ZeissButton
            type="primary"
            className="pc-createAnn-sales"
            onClick={addSubjectMatterClick}
          >
            确认添加
          </ZeissButton>
        </Space>
      </div>
    </ZeissModal>
  );
};
